import React, { ReactNode, Suspense } from 'react';
import { PageSwitcherProps } from './types';

function PageSwitcher(
  {
    isOnBetaPage,
    isOnDataLoaderPage,
    betaPageComponent,
    dataLoaderComponent,
    children,
  }: PageSwitcherProps) {

  if (isOnBetaPage) {
    return <Suspense fallback={null}>
      {betaPageComponent}
    </Suspense>;
  }

  if (isOnDataLoaderPage) {
    return <Suspense fallback={null}>
      {dataLoaderComponent}
    </Suspense>;
  }

  return children;
}

export default PageSwitcher;
